module.exports = __webpack_public_path__ + "img/my.95fe971d.svg";